import ChartDonutColor from './ChartDonutColour.svg';
import ChartDonutDark from './ChartDonutDark.svg';
import ChartDonutLight from './ChartDonutLight.svg';
export const chartDonut = { color: ChartDonutColor, dark: ChartDonutDark, light: ChartDonutLight };
//# sourceMappingURL=index.js.map